import { animate, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MediumUploadDTOAndTags } from 'src/app/models/taggable.model';
import { CompanyDTO, FolderDTO, ResolutionDTO } from 'src/app/services/api/api';
import { TagService } from 'src/app/services/tag.service';
import { UtilService } from 'src/app/services/util.service';
import { MediumUploadDTO } from '../medium-explorer.component';
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '../../../../services/permission.service';
import { StringTransformationService } from '../../../../services/transformation-helper/string-transformation.service';

@Component({
  selector: '[app-medium-edit]',
  templateUrl: './medium-edit.component.html',
  styleUrls: ['./medium-edit.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate(250, style({ opacity: 1 }))]),
      transition(':leave', [animate(500, style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class MediumEditComponent {
  readonly stringTransformation = inject(StringTransformationService);

  @Input()
  previewMedium: MediumUploadDTOAndTags;
  @Input()
  isInModalContext: boolean;
  @Input()
  modalType: string;

  @Input()
  selectedCompany: CompanyDTO;
  @Input()
  preselectedCompany: CompanyDTO;
  @Input()
  selectedMedias: MediumUploadDTOAndTags[];
  @Input() selectedFolder: FolderDTO;
  @Input()
  resolutionOptions: ResolutionDTO[];

  @Output()
  closeClick: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  mediumNameChanged: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();
  @Output()
  openFilePicker: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  openFileReplacePicker: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();
  @Output()
  dropHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  lockMedium: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();
  @Output()
  deleteMedium: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();
  @Output()
  selectCompany: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();
  @Output()
  preSelectCompany: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  toggleMediumSelection: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();
  @Output()
  addMediumToBooking: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();
  @Output()
  showTemplatePreview: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();
  @Output()
  selectTemplateGroup: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();
  @Output()
  deleteTemplateGroup: EventEmitter<MediumUploadDTOAndTags> = new EventEmitter<MediumUploadDTOAndTags>();

  isDragOver: boolean;

  constructor(
    public util: UtilService,
    public tagService: TagService,
    public translate: TranslateService,
    public permissionService: PermissionService
  ) {}

  dragOverHandler(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  isMediumInSelectedMedias(medium: MediumUploadDTO): boolean {
    return this.selectedMedias.findIndex(x => x.id === medium.id) !== -1;
  }

  getPromotedProductsText(): string {
    if (this.previewMedium.promotedProducts) {
      return this.previewMedium.promotedProducts.map(prod => prod.name).join(', ');
    } else {
      return '';
    }
  }

  displayNoMatchingMarker(): boolean {
    if (this.previewMedium?.resolution && this.resolutionOptions && this.resolutionOptions.length > 0) {
      for (const resolution of this.resolutionOptions) {
        if (resolution.id === this.previewMedium.resolution.id) {
          return false;
        }
      }
    }
    return true;
  }
}
